export default class PlaceholderImageHtml {
    constructor(width = 1, height = 1, config) {
        this._width = width;
        this._height = height;
        this._config = config;
    }

    toString() {

        const $globalConfig = config;

        const html = `<div class="rfct-placeholder-image">
            <div class="rfct-placeholder-image__ratio" style="padding-top: ${((this._height / this._width) * 100).toFixed(5)}%;"></div>
            <div class="rfct-placeholder-image__small">
                <img src="${$globalConfig.images.noImage}">
            </div>
        </div>`;

        return html;
    }
}
